import { Button, ButtonProps } from "@mui/material";
import React, { ReactNode } from "react";
type CustomButtonProps =  ButtonProps & {
    isDisabledBG?: Boolean,
    onClick: () =>void,
    children: ReactNode;
};
const CTAButton : React.FC<CustomButtonProps>= (props) => {
    const { isDisabledBG = false, onClick,children, disabled, ...buttonProps } = props;
    return <Button
        {...buttonProps}
        disabled={disabled}
        fullWidth
        onClick={onClick}
        style={{
            color: "white",
            backgroundColor: isDisabledBG
                ? "#CBCBCB"
                : "#1F8268",
            fontFamily: ['Inter-SemiBold', 'Roboto-Flex-SemiBold'].join(","),
            fontSize: "16px",
        }}
    >
        {children}
    </Button>;
};
export default CTAButton;
